import { useAuth } from '../context/AuthContext';
import ProfilePage from './ProfilePage';
import ParentSettingsPage from './ParentSettingsPage';

/**
 * Routes parents to the parent-specific settings UI (billing, family, etc.)
 * and everyone else to the standard ProfilePage.
 */
export default function ProfileRouter() {
  const { user } = useAuth();
  if (user?.role === 'parent') return <ParentSettingsPage />;
  return <ProfilePage />;
}
